import AnimatedCheckmark from '@/components/animations/AnimatedCheckmark';
import ShareLinkPanel from '@/components/share/ShareLinkPanel';

interface AssignSuccessStepProps {
    title: string;
    description: string;
    expiryDate?: string;
    shareText?: string;
    shareLink?: string;
}

export default function AssignSuccessStep({
    title,
    description,
    expiryDate,
    shareText,
    shareLink,
}: AssignSuccessStepProps) {
    return (
        <div className="space-y-6">
            <div className="text-center">
                <div className="mx-auto mb-3 flex size-12 items-center justify-center rounded-full bg-green-100">
                    <AnimatedCheckmark className="size-12" />
                </div>
                <h3 className="text-lg font-medium text-foreground">{title}</h3>
                <p className="mt-1 text-muted-foreground">{description}</p>
            </div>

            {expiryDate && (
                <div className="rounded-lg border border-border bg-surface p-4">
                    <p className="text-xs text-muted-foreground">
                        Link válido até: <span className="font-medium">{expiryDate}</span>
                    </p>
                </div>
            )}

            {shareLink && shareText && (
                <ShareLinkPanel shareText={shareText} shareLink={shareLink} />
            )}
        </div>
    );
}
